import { render, staticRenderFns } from "./DashboardShell.vue?vue&type=template&id=25a4bc72"
import script from "./DashboardShell.vue?vue&type=script&lang=js"
export * from "./DashboardShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports